import { createStyles, makeStyles } from '@material-ui/core';
export var monolithMStart = 376;
export var monolithEmbeddedStarts = 541;
export var monolithLStarts = 990;
export var useEmbeddedSignUpStyles = makeStyles(function (_a) {
    var _b, _c, _d;
    var spacing = _a.spacing, typography = _a.typography;
    return createStyles({
        form: (_b = {},
            _b["@media (min-width:" + monolithMStart + "px)"] = {
                width: 330,
            },
            _b["@media (min-width:" + monolithEmbeddedStarts + "px)"] = {
                width: '100%',
            },
            _b),
        marketing: (_c = {
                display: 'none',
                fontFamily: ['"Kumlien Pro"', 'serif'].join(','),
                textAlign: 'center',
                marginBottom: spacing(0.5)
            },
            _c["@media (min-width:" + monolithEmbeddedStarts + "px)"] = {
                display: 'block',
            },
            _c),
        subTitle: (_d = {
                marginBottom: spacing(3),
                textAlign: 'center'
            },
            _d["@media (min-width:" + monolithEmbeddedStarts + "px)"] = {
                fontSize: typography.body2.fontSize,
                lineHeight: typography.body2.lineHeight,
                fontWeight: typography.body2.fontWeight,
            },
            _d),
    });
});
export var useEmbeddedSignUpCardStyles = makeStyles(function (_a) {
    var _b;
    var spacing = _a.spacing;
    return createStyles({
        root: (_b = {
                alignItems: 'center',
                borderRadius: 0,
                boxShadow: 'none',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                padding: spacing(4, 3),
                width: '100%',
                '& .MuiButton-startIcon': {
                    marginRight: spacing(6.75),
                }
            },
            _b["@media (min-width:" + monolithEmbeddedStarts + "px)"] = {
                borderRadius: spacing(2),
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                width: 346,
                '& .MuiButton-startIcon': {
                    marginRight: spacing(4.875),
                },
            },
            _b["@media (min-width:" + monolithLStarts + "px)"] = {
                width: 407,
                '& .MuiButton-startIcon': {
                    marginRight: spacing(8.75),
                },
            },
            _b),
    });
});
//# sourceMappingURL=EmbeddedSignUpTypes.js.map